import { render, staticRenderFns } from "./FR_form.vue?vue&type=template&id=2c435506&"
import script from "./FR_form.vue?vue&type=script&lang=js&"
export * from "./FR_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports